var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindingMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(-285 1709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 72,
    height: 72,
    transform: "translate(285 -1709)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(283.115 -1715.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(4.613 8.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M22.211,10.891A27.622,27.622,0,0,0,5.09,39.9C7.481,58.818,28.3,69.585,45.344,60.47q11.136-5.95,14.3-19.705a.4.4,0,0,0-.132-.439q-.36-.316-.492.149c-.738,2.663.378,5.124-3.806,4.781a1.346,1.346,0,0,0-1.477.9C49.211,57.078,35.553,62.7,24.778,58.836.985,50.292,4.9,16.076,29.946,13.009a22.578,22.578,0,0,1,21.428,9.51q1.485,2.109,4.781.94.387-.132.176-.475C49.036,11.005,35.219,5.609,22.211,10.891",
    transform: "translate(-4.872 -8.864)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M39.415,16.277c-16.541-4.2-31.773,9.941-27.246,26.578q.123.457.4.079a65.419,65.419,0,0,0,6.2-9.4C23.331,24.3,26.873,14.9,39.45,16.752a.086.086,0,0,0,.105-.088q0-.123-.009-.22a.17.17,0,0,0-.132-.167",
    transform: "translate(-5.658 -9.671)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M33.8,63.677a10.051,10.051,0,0,0,4.746-.176.514.514,0,0,0,.413-.475l.686-5.845a.459.459,0,0,0-.378-.554L34.134,55.38",
    transform: "translate(-8.375 -14.497)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M33.035,51.615c-7.3-2.522-9.281-4.2-7.9-12.094a70.556,70.556,0,0,1,3.621-13.149,1.459,1.459,0,0,1,.422-.642q.729-.589,1.283.29a.817.817,0,0,1,.053.747A57.184,57.184,0,0,0,26.127,44.9a1.072,1.072,0,0,0,.272.817c3.067,3.56,9.273,4.9,13.737,5.6a1.376,1.376,0,0,0,.817-.114c4.588-2.145,6.223-7.33,2.663-11.268C40.892,36.92,32.956,28.649,35.311,24.7a.835.835,0,0,1,1.529.633c-.615,2.443,1.441,5.669,3.771,8.271",
    transform: "translate(-7.276 -10.732)",
    fill: "none",
    stroke: "#89813b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M42.8,33.448c2.733,3.472,5.731,5.458,6.8,10.046a.613.613,0,0,0,.58.51L60.7,45.19a.606.606,0,0,0,.738-.51l.237-.958a.879.879,0,0,0-.993-1.072c-3.489.571-9.079-.325-10.336-4.368a.606.606,0,0,1,1.02-.6c5.59,5.985,15.768,4.1,15.987-5.238a.628.628,0,0,0-.492-.633,3.817,3.817,0,0,1-3.094-3.059,1.828,1.828,0,0,0-1.7-1.406l-6.4-.281a.664.664,0,0,1-.633-.439A10.3,10.3,0,0,0,52.5,22.98",
    transform: "translate(-9.465 -10.574)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M48.919,22.454c-5.827-5.564-19.125-5.282-23.168,2.426C21.62,32.746,18.552,39,13.376,45.227a.667.667,0,0,0-.105.756Q18.491,57.5,31.305,59.228",
    transform: "translate(-5.881 -10.048)",
    fill: "none",
    stroke: "#89813b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M52.5,22.98c-1.978,2.118-.246,4.034.747,6.047a.741.741,0,0,1-.141.932L51.475,31.62a.581.581,0,0,1-.413.167A20.958,20.958,0,0,0,42.8,33.448",
    transform: "translate(-9.465 -10.574)",
    fill: "none",
    stroke: "#f9f0a9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M34.091,55.38a18.607,18.607,0,0,0-.334,8.3",
    transform: "translate(-8.332 -14.497)",
    fill: "none",
    stroke: "#f9f0a9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M55.789,49.822l-6.029-.7a.49.49,0,0,0-.615.483,7.092,7.092,0,0,1-6.126,6.653.613.613,0,0,0-.536.606l-.343,4.781a.571.571,0,0,0,.729.589A21.752,21.752,0,0,0,56.413,50.991q.536-1.037-.624-1.169",
    transform: "translate(-9.385 -13.738)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M65.388,67.012a.237.237,0,0,0,0-.336l-4.054-4.026a.237.237,0,0,0-.336,0l-2.353,2.37a.237.237,0,0,0,0,.336L62.7,69.383a.237.237,0,0,0,.336,0l2.353-2.37",
    transform: "translate(-11.375 -15.369)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M78.167,79.9a2.224,2.224,0,0,0-.011-3.145l-7.6-7.543a2.224,2.224,0,0,0-3.145.011l-2.229,2.245a2.224,2.224,0,0,0,.011,3.145l7.6,7.543a2.224,2.224,0,0,0,3.145-.011L78.167,79.9",
    transform: "translate(-12.097 -16.093)",
    fill: "none",
    stroke: "#89813b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M52.136,28.548a1.758,1.758,0,1,0-1.758,1.758,1.758,1.758,0,0,0,1.758-1.758",
    transform: "translate(-10.17 -11.035)",
    fill: "none",
    stroke: "#89813b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M61.523,36.208q-.352.545.3.545h1.063q.571,0,.369-.527l-.29-.756q-.369-.976-.923-.1l-.519.835",
    transform: "translate(-11.717 -12.024)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M60.357,39.247q1.055-.483.527-1.362a.532.532,0,0,0-.346-.246.514.514,0,0,0-.41.088l-.519.387a.352.352,0,0,0-.1.457l.281.492a.391.391,0,0,0,.563.185",
    transform: "translate(-11.483 -12.347)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M64.945,39.15a.953.953,0,1,0-1.152-.443.879.879,0,0,0,1.152.443",
    transform: "translate(-11.991 -12.321)",
    fill: "none",
    stroke: "#8f9091",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M12.89,14.046C25.248,2.9,44.672,4.975,55.148,18.106a43.275,43.275,0,0,1,3.27,5.142.738.738,0,0,0,.606.369l5.388.193a.606.606,0,0,1,.659.642,22.61,22.61,0,0,1-2.742,12.463,10.906,10.906,0,0,0-1.248,3.533A31.865,31.865,0,0,1,55.7,53.685a.554.554,0,0,0,.07.712l4.386,4.395a1.1,1.1,0,0,0,.853.334,4,4,0,0,1,2.98.87c3.56,3.507,8.508,7.655,8.991,10.257.422,2.285-1.564,4.315-3.2,5.731-2.751,2.373-4.544,1.248-6.856-1.037-2.487-2.461-7.945-6.645-7.954-10.275A.927.927,0,0,0,54.691,64l-4.474-4.359a.472.472,0,0,0-.668-.044C18.893,81.309-14.514,38.769,12.89,14.046Zm9.062-3.4A27.622,27.622,0,0,0,4.831,39.657C7.221,58.571,28.043,69.338,45.085,60.224q11.136-5.95,14.3-19.705a.4.4,0,0,0-.132-.439q-.36-.316-.492.149c-.738,2.663.378,5.124-3.806,4.781a1.346,1.346,0,0,0-1.477.9c-4.526,10.925-18.185,16.55-28.96,12.683C.726,50.046,4.637,15.83,29.686,12.762a22.578,22.578,0,0,1,21.428,9.51q1.485,2.109,4.781.94.387-.132.176-.475C48.776,10.758,34.96,5.362,21.952,10.644ZM38.37,15.223C21.829,11.022,6.6,25.164,11.124,41.8q.123.457.4.079a65.419,65.419,0,0,0,6.2-9.4c4.562-9.229,8.1-18.633,20.681-16.778a.086.086,0,0,0,.105-.088q0-.123-.009-.22A.17.17,0,0,0,38.37,15.223ZM30.038,57.8a10.051,10.051,0,0,0,4.746-.176.514.514,0,0,0,.413-.475l.686-5.845a.459.459,0,0,0-.378-.554L30.372,49.5c-7.3-2.522-9.281-4.2-7.9-12.094a70.556,70.556,0,0,1,3.621-13.149,1.459,1.459,0,0,1,.422-.642q.729-.589,1.283.29a.817.817,0,0,1,.053.747,57.184,57.184,0,0,0-4.386,18.132,1.072,1.072,0,0,0,.272.817c3.067,3.56,9.273,4.9,13.737,5.6a1.376,1.376,0,0,0,.817-.114c4.588-2.145,6.223-7.33,2.663-11.268-2.725-3.015-10.661-11.285-8.306-15.232a.835.835,0,0,1,1.529.633c-.615,2.443,1.441,5.669,3.771,8.271,2.733,3.472,5.731,5.458,6.8,10.046a.613.613,0,0,0,.58.51l10.521,1.187a.606.606,0,0,0,.738-.51l.237-.958a.879.879,0,0,0-.993-1.072c-3.489.571-9.079-.325-10.336-4.368a.606.606,0,0,1,1.02-.6c5.59,5.985,15.768,4.1,15.987-5.238a.628.628,0,0,0-.492-.633A3.817,3.817,0,0,1,58.919,26.8a1.828,1.828,0,0,0-1.7-1.406l-6.4-.281a.664.664,0,0,1-.633-.439,10.3,10.3,0,0,0-2.54-3.647c-5.827-5.564-19.125-5.282-23.168,2.426-4.131,7.866-7.2,14.124-12.375,20.347a.667.667,0,0,0-.105.756Q17.223,56.066,30.038,57.8Zm20.98-13.1L44.988,44a.49.49,0,0,0-.615.483,7.091,7.091,0,0,1-6.126,6.653.613.613,0,0,0-.536.606l-.343,4.781a.571.571,0,0,0,.729.589A21.752,21.752,0,0,0,51.642,45.871Q52.178,44.834,51.018,44.7Zm7.608,15.559a.237.237,0,0,0,0-.336L54.571,55.9a.237.237,0,0,0-.336,0l-2.353,2.37a.237.237,0,0,0,0,.336l4.054,4.026a.237.237,0,0,0,.336,0ZM70.683,72.42a2.224,2.224,0,0,0-.011-3.145l-7.6-7.543a2.224,2.224,0,0,0-3.145.011L57.7,63.988a2.224,2.224,0,0,0,.011,3.145l7.6,7.543a2.224,2.224,0,0,0,3.145-.011Z",
    transform: "translate(0 0)",
    fill: "#1f2022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M5.09,39.9A27.622,27.622,0,0,1,22.211,10.891c13.008-5.282,26.824.114,34.119,12.094q.211.343-.176.475-3.3,1.169-4.781-.94a22.578,22.578,0,0,0-21.428-9.51C4.9,16.076.985,50.292,24.778,58.836c10.775,3.867,24.434-1.758,28.96-12.683a1.346,1.346,0,0,1,1.477-.9c4.184.343,3.067-2.118,3.806-4.781q.132-.466.492-.149a.4.4,0,0,1,.132.439Q56.48,54.52,45.344,60.47C28.3,69.585,7.481,58.818,5.09,39.9Z",
    transform: "translate(-0.259 -0.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M12.169,42.855C7.642,26.218,22.874,12.076,39.415,16.277a.17.17,0,0,1,.132.167q.009.1.009.22a.086.086,0,0,1-.105.088C26.873,14.9,23.331,24.3,18.769,33.53a65.419,65.419,0,0,1-6.2,9.4Q12.292,43.312,12.169,42.855Z",
    transform: "translate(-1.045 -1.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M48.919,22.454c-1.978,2.118-.246,4.034.747,6.047a.741.741,0,0,1-.141.932l-1.635,1.661a.581.581,0,0,1-.413.167,20.958,20.958,0,0,0-8.262,1.661c-2.329-2.6-4.386-5.827-3.771-8.271a.835.835,0,0,0-1.529-.633C31.56,27.965,39.5,36.236,42.222,39.25c3.56,3.938,1.925,9.123-2.663,11.268a1.376,1.376,0,0,1-.817.114c-4.465-.7-10.67-2.039-13.737-5.6a1.072,1.072,0,0,1-.272-.817,57.184,57.184,0,0,1,4.386-18.132.817.817,0,0,0-.053-.747q-.554-.879-1.283-.29a1.459,1.459,0,0,0-.422.642,70.556,70.556,0,0,0-3.621,13.149c-1.38,7.893.6,9.571,7.9,12.094a18.607,18.607,0,0,0-.334,8.3Q18.491,57.5,13.27,45.983a.667.667,0,0,1,.105-.756C18.552,39,21.62,32.746,25.751,24.88,29.794,17.172,43.092,16.891,48.919,22.454Zm-1.072,5.106a1.758,1.758,0,1,0-1.758,1.758A1.758,1.758,0,0,0,47.847,27.561Z",
    transform: "translate(-1.268 -1.43)",
    fill: "#f2e153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M52.5,22.98a10.3,10.3,0,0,1,2.54,3.647.664.664,0,0,0,.633.439l6.4.281a1.828,1.828,0,0,1,1.7,1.406,3.817,3.817,0,0,0,3.094,3.059.628.628,0,0,1,.492.633c-.22,9.343-10.4,11.224-15.987,5.238a.606.606,0,0,0-1.02.6c1.257,4.043,6.847,4.939,10.336,4.368a.879.879,0,0,1,.993,1.072l-.237.958a.606.606,0,0,1-.738.51L50.183,44a.613.613,0,0,1-.58-.51c-1.072-4.588-4.069-6.574-6.8-10.046a20.958,20.958,0,0,1,8.262-1.661.581.581,0,0,0,.413-.167l1.635-1.661a.741.741,0,0,0,.141-.932C52.257,27.014,50.526,25.1,52.5,22.98Zm6.768,11.777q-.352.545.3.545h1.063q.571,0,.369-.527l-.29-.756q-.369-.976-.923-.1Zm-.932,2.716q1.055-.483.527-1.362a.532.532,0,0,0-.346-.246.514.514,0,0,0-.41.088l-.519.387a.352.352,0,0,0-.1.457l.281.492A.391.391,0,0,0,58.339,37.473Zm4.08-.071a.953.953,0,1,0-1.152-.443.879.879,0,0,0,1.152.443Z",
    transform: "translate(-4.852 -1.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 1.758,
    cy: 1.758,
    r: 1.758,
    transform: "translate(43.063 24.373)",
    fill: "#1f2022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M61.523,36.208l.519-.835q.554-.879.923.1l.29.756q.2.527-.369.527H61.822Q61.171,36.753,61.523,36.208Z",
    transform: "translate(-7.104 -3.406)",
    fill: "#1f2022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M59.795,39.062l-.281-.492a.352.352,0,0,1,.1-.457l.519-.387a.514.514,0,0,1,.41-.088.532.532,0,0,1,.346.246q.527.879-.527,1.362A.391.391,0,0,1,59.795,39.062Z",
    transform: "translate(-6.87 -3.729)",
    fill: "#1f2022"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 0.94,
    cy: 0.8,
    rx: 0.94,
    ry: 0.8,
    transform: "translate(57.369 33.412) rotate(61.4)",
    fill: "#1f2022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M55.789,49.822q1.16.132.624,1.169A21.752,21.752,0,0,1,42.869,62.233a.571.571,0,0,1-.729-.589l.343-4.781a.613.613,0,0,1,.536-.606A7.092,7.092,0,0,0,49.145,49.6a.49.49,0,0,1,.615-.483Z",
    transform: "translate(-4.772 -5.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M34.091,55.38l5.133,1.248a.459.459,0,0,1,.378.554l-.686,5.845a.514.514,0,0,1-.413.475,10.051,10.051,0,0,1-4.746.176A18.607,18.607,0,0,1,34.091,55.38Z",
    transform: "translate(-3.719 -5.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 6.188,
    height: 3.814,
    rx: 0.27,
    transform: "translate(54.403 55.732) rotate(44.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 15.152,
    height: 7.611,
    rx: 2.53,
    transform: "translate(61.498 60.165) rotate(44.8)",
    fill: "#f2e153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindingMode);
export default __webpack_public_path__ + "static/media/finding-mode.7dba7d13d5742cb8c2a5f9df8f492754.svg";
export { ForwardRef as ReactComponent };